import React, { use } from 'react';

import { useHeaderPromoRibbonContent } from 'src/components/layout/redesign/club-header-desktop/use-header-promo-ribbon-content';
import HeaderDesktop from 'src/components/layout/redesign/header-desktop';
import type { HeaderButtonProps } from 'src/components/layout/redesign/header-mobile/header-button';
import PromoRibbon from 'src/components/layout/redesign/header-shared/promo-ribbon';
import { ClubCmsContent } from 'src/content/club-content-consumer';
import { SiteContext } from 'src/context/site-context';
import { amplitudeButtonTrackEvent } from 'src/helpers/amplitude-event-track';

type ClubHeaderDesktopProps = {
  disablePromoRibbon?: boolean;
};

const ClubHeaderDesktop = ({ disablePromoRibbon = false }: ClubHeaderDesktopProps) => {
  const { headerContent } = use(ClubCmsContent);
  const { pageLevel, buildType, language } = use(SiteContext);

  const promoRibbonContent = useHeaderPromoRibbonContent();

  const buttonSettings = (
    button: Queries.RedesignButton | undefined
  ): HeaderButtonProps | undefined => {
    return button
      ? {
          type: 'link',
          buttonProps: button,
          handleClick: () => {
            void amplitudeButtonTrackEvent({
              buildType,
              language,
              button,
              componentName: 'Club Desktop Header',
              pageLevel,
              ctaEventName: 'Primary Or Secondary Button - Navigation',
            });
          },
        }
      : undefined;
  };

  return (
    <HeaderDesktop
      headerContent={headerContent}
      primaryButton={buttonSettings(headerContent?.headerButtonPrimary)}
      secondaryButton={buttonSettings(headerContent?.headerButtonSecondary)}
      ribbonChildren={
        !disablePromoRibbon &&
        promoRibbonContent && <PromoRibbon promoRibbon={promoRibbonContent} />
      }
    />
  );
};

export default ClubHeaderDesktop;
